import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { getFallbackAvatarColor } from "@/lib/avatar";
import { cn } from "@/lib/utils";

type UserAvatarProps = Omit<React.ComponentProps<typeof Avatar>, "children"> & {
  userId?: string | null;
  name: string;
  size?: "sm" | "md" | "lg";
};

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-8 w-8",
  lg: "h-16 w-16",
} as const;

const fallbackSizeClasses = {
  sm: "text-xs",
  md: undefined,
  lg: "text-2xl",
} as const;

export function UserAvatar({
  userId,
  name,
  size = "md",
  className,
  ...props
}: UserAvatarProps) {
  const { bg, fg, border } = getFallbackAvatarColor(userId ?? name);

  return (
    <Avatar
      className={cn("overflow-visible", sizeClasses[size], className)}
      {...props}
    >
      <AvatarFallback
        className={cn("font-bold", fallbackSizeClasses[size])}
        style={{
          background: bg,
          color: fg,
          border: `1px solid ${border}`,
          boxShadow: `0 ${size === "sm" ? "1px" : "2px"} 0 0 ${border}`,
        }}
      >
        {name.charAt(0)}
      </AvatarFallback>
    </Avatar>
  );
}
